<template>
    <div class="title">{{title}}</div>
</template>

<script>
    export default {
        name: "z-title",
        props:{
            title:String
        }
    }
</script>

<style scoped lang="scss">
.title{
    color: #015478;
    font-size: 16px;
    height: 24px;
    line-height: 24px;
    border-left: 6px solid #3b87e4;
    padding: 0 16px;
    margin-bottom: 5px;
}
</style>